import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../utilities';
import { Container, Heading } from './ui';
import Accordion from './Accordion';

const Accordions = styled.section`
  ${sectionMargins()};
`;

const AccordionItem = styled.li`
  margin-top: 10px;
  &:first-child {
    margin-top: 0;
  }
`;

const HeadingWrap = styled.div`
  text-align: center;
  margin-bottom: 38px;
  ${minBreakpointQuery.large`
    margin-bottom: 52px;
  `}
`;

export default ({ heading, accordions }) => {
  return (
    <Accordions>
      <Container>
        <HeadingWrap>
          <Heading>{heading}</Heading>
        </HeadingWrap>
        {accordions && (
          <ul>
            {accordions.map(({ heading, text, id }) => (
              <AccordionItem key={id}>
                <Accordion heading={heading} text={text} />
              </AccordionItem>
            ))}
          </ul>
        )}
      </Container>
    </Accordions>
  );
};
